export default __webpack_public_path__ + "static/media/iol-logo.33555f2d.svg";